import { useTranslate } from "ui/locale";
import { APP_BAR_TITLES } from "./AppBarHeader.constants";
import { Typography } from "@commonlibs";
import { matchPath, useLocation } from "react-router-dom";
import SearchInput from "../SearchInput/SearchInput";
import { HeaderIcon } from "../../Header/Header.styles";
import { BackIcon } from "ui/common/icons";
import { AppBarHeaderTitleRoot } from "./AppBarHeaderTitle.styles";
import useTitleBackButton from "./hook/useTitleBackButton";

export interface AppBarHeaderTitleProps {
    className?: string;
    style?: React.CSSProperties;
    titleColor?: string;
    onClickBack?: () => void;
}

function AppBarHeaderTitle({ titleColor, onClickBack }: AppBarHeaderTitleProps) {
    const translate = useTranslate();
    const location = useLocation();
    const { onClickBackButton } = useTitleBackButton();

    const APP_BAR_TITLES_ROUTES = Object.keys(APP_BAR_TITLES);
    const wildcardIndex = APP_BAR_TITLES_ROUTES.find((route) => matchPath(route, location.pathname)) ?? "";
    const wilcardTitle = APP_BAR_TITLES[wildcardIndex];
    const title = APP_BAR_TITLES[location.pathname] ?? wilcardTitle;

    function goToMain() {
        onClickBackButton()
    }

    return title ? (
        <AppBarHeaderTitleRoot>
            <HeaderIcon data-testid="back-button" as={BackIcon} style={{ fontSize: "1.5rem", color: titleColor }} onClick={onClickBack || goToMain} />
            <Typography variant="body1Strong" textAlign="center" color={titleColor || "white"}>
                {translate(title)}
            </Typography>
        </AppBarHeaderTitleRoot>
    ) : (
        <SearchInput />
    );
}

export default AppBarHeaderTitle;
